import { ProductRespDTO, SkuRespDTO } from "@/service/goods";
import { floatingRate } from "@/util/useYan";
import { t } from "@/plugins/i18n";
import { CustomerAdditionTemplateItemInfoRespDTO } from "@/service/settlement";

export const getUnderLineProductPrice = (data: any) => {
  // 阶梯价
  const productPriceLadderList = data?.productPriceLadderList || [];
  // 阶梯价最高最低价
  let min = 0;
  let max = 0;
  productPriceLadderList.forEach((item: any) => {
    min = min ? Math.min(item.price, min) : item.price;
    max = max ? Math.max(item.price, max) : item.price;
  });
  // sku最大值最小值
  let skuMin = 0;
  let skuMax = 0;
  data.skuList.forEach((item: any) => {
    skuMin = skuMin
      ? Math.min(item.productSellPrice, skuMin)
      : item.productSellPrice;
    skuMax = skuMax
      ? Math.max(item.productSellPrice, skuMax)
      : item.productSellPrice;
  });
  // 价格取finalProductSellPrice finalProductSellPriceJpy
  // sku 取 skulist 下productSellPrice
  // 商品金额取 productSellPrice
  // 线下商品
  if (data.channel === 5) {
    if (productPriceLadderList.length > 0) {
      // 线下商品维护阶梯价
      // 价格：取阶梯价格区间
      data.finalProductSellPrice = min === max ? min : `${min}-${max}`;
      data.finalProductSellPriceJpy =
        min === max
          ? Math.round(min * floatingRate.value)
          : `${Math.round(min * floatingRate.value)}-${Math.round(
              max * floatingRate.value
            )}`;
      // sku单价：默认取阶梯价的最高价格，当加购数量达到下一个阶梯，则更新sku单价
      data.skuList.forEach((i: any) => {
        i.productSellPrice = max;
      });
      // 商品价格：取sku单价最大值
      data.productSellPrice = max;
    } else {
      // 未维护阶梯价
      // 取该spu下所有sku单价的区间展示
      data.finalProductSellPrice =
        skuMin === skuMax ? skuMin : `${skuMin}-${skuMax}`;
      data.finalProductSellPriceJpy =
        skuMin === skuMax
          ? Math.round(skuMin * floatingRate.value)
          : `${Math.round(skuMin * floatingRate.value)}-${Math.round(
              skuMax * floatingRate.value
            )}`;
      // 商品金额：取sku单价最小值
      data.productSellPrice = skuMin;
    }
  }
  return data;
};

export interface extSkuRespDTO extends SkuRespDTO {
  categoryCode?: string;
  adaptType?: string;
  adaptTypeModifyFlag?: boolean;
  isLive?: boolean;
  additionIdList?: number[];
  additionList?: CustomerAdditionTemplateItemInfoRespDTO[];
}
export interface extProductRespDTO extends ProductRespDTO {
  ladder?: any;
  showLladder?: boolean;
  consignRangePrice?: any;
  finalProductSellPrice?: string;
  supplierSpu?: string;
  adaptTypeModifyFlag?: boolean;
  /** 季节属性 */
  seasonTag?: string;
  isfavo?: number;
  finalProductSellPriceJpy?: string;
  /** 是否一价全包商品 */
  isAllCal?: boolean;
  /** 商品后台分类 */
  categoryCode?: string;
  skuList: extSkuRespDTO[];
}
